// THIS FILE IS GENERATED. ANY CHANGES TO THIS FILE WILL BE LOST.
import type { TOC } from '@ember/component/template-only';

export interface BusinessGraphBarIconSignature {
  Element: SVGSVGElement;
}

export const BusinessGraphBarIcon: TOC<BusinessGraphBarIconSignature> = <template><svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" ...attributes>
<path fill-rule="evenodd" clip-rule="evenodd" d="M22 9V22H24V24H0V22H2V12.999C2 12.448 2.447 11.999 3 11.999H7C7.553 11.999 8 12.448 8 12.999V22H9V14.999C9 14.448 9.447 13.999 10 13.999H14C14.553 13.999 15 14.448 15 14.999V22H16V9C16 8.448 16.447 8 17 8H21C21.553 8 22 8.448 22 9ZM20 10H18V21.999H20V10ZM11 15.999H13V21.999H11V15.999ZM6 13.999H4V21.999H6V13.999Z"/>
</svg>
</template>;